<template>
    <dialog :open="open" class="action-dialog">
        <h3>Заблокировать пользователя?</h3>
        <label>Причина блокировки
            <textarea v-model="reason" rows="3" />
        </label>
        <label>Заблокировать до (опционально)
            <input v-model="until" type="datetime-local" />
        </label>
        <div class="actions">
            <button class="btn btn--danger" :disabled="busy" @click="submit">
                {{ busy ? 'Блокирую…' : 'Заблокировать' }}
            </button>
            <button class="btn" @click="$emit('close')">Отмена</button>
        </div>
    </dialog>
</template>

<script setup lang="ts">
import { ref } from 'vue';
import { request } from '@/admin/shared/api/httpClient';

const props = defineProps<{ open: boolean; userId: () => string }>();
const emit = defineEmits<{ (e: 'close'): void; (e: 'done'): void }>();

const reason = ref('');
const until = ref('');
const busy = ref(false);

async function submit(): Promise<void> {
    busy.value = true;
    try {
        await request({
            method: 'post',
            url: `/admin-api/users/${props.userId()}/ban/`,
            data: {
                reason: reason.value,
                until: until.value ? new Date(until.value).toISOString() : null,
            },
        });
        emit('done');
    } finally {
        busy.value = false;
    }
}
</script>

<style scoped>
.action-dialog {
    padding: 1.5rem;
    border-radius: var(--admin-radius-sm);
    border: 1px solid var(--admin-border);
    box-sizing: border-box;
    /* только max-width: на десктопе диалог остаётся fit-content, как был */
    max-width: min(440px, 92vw);
    max-height: 90vh;
    overflow-y: auto;
}
.action-dialog label {
    display: block;
    margin-bottom: 0.75rem;
}
.actions {
    display: flex;
    flex-wrap: wrap;
    gap: 0.5rem;
}

@media (max-width: 640px) {
    /* iOS зумит страницу при фокусе, если шрифт поля меньше 1rem */
    .action-dialog textarea,
    .action-dialog input { width: 100%; box-sizing: border-box; font-size: 1rem; }
    .action-dialog input { min-height: 2.5rem; }
    .actions .btn { min-height: 2.5rem; }
}
</style>
